import { setRemoteDefinitions } from '@nx/angular/mf';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let process: any;
const env = process.env.NODE_ENV;
let moduleFederationManifest = '/assets/module-federation.manifest.json';
if (env === 'development') {
  moduleFederationManifest = '/assets/module-federation.dev.manifest.json';
}

fetch(moduleFederationManifest)
  .then((res) => res.json())
  .then((definitions) => setRemoteDefinitions(definitions))
  // eslint-disable-next-line local-rules/no-console
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
